import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import {Link} from "react-router-dom";
import {connect}  from  "react-redux";
import axios from "axios";
import { useLocation } from 'react-router-dom'


class TableauWorkbook extends Component{
    constructor(props) {
        super(props);

        this.state = {
            reportPermissionsArray:[],
            tableau_workbook:[],
            project_name:""
        }
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
    }
    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);

        this.get_tableau_workbook(this.props.match.params.id, decoded.user_department);
    }

    get_tableau_workbook(project_id, user_department){
        axios.post(config.get('API_URL')+'/tableau/get-tableau-workbook/',
         {
            project_id:project_id,
            user_department:user_department
         },
         {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {

            if(response.data.length<1){
                alert("You Don't have permission to view this reports")
            } else {
                this.setState({
                tableau_workbook: response.data,
                project_name: response.data[0].project_name
            })
        }

        }).catch( err => {
            console.log(err);
        });
    }
    render() {

        let projectData = this.state.tableau_workbook.map((val,index) => {
             let linkUrl = "/admin/tableau-worksheet/"+val.workbook_id;
            return (
                <div className="col-lg-3 col-xs-6" key={index}>
                    <div className="card report-dash">
                        <div className="content text-center">
                            <Link className="" to={linkUrl}>
                                <div className="report-thumbs-ico">
                                    <div className="icon-big text-center folder-icon">
                                        <i className="fa fa-folder-o"></i>
                                    </div>
                                    <h5>{val.workbook_name}</h5>
                                   {/*<p className="text-muted">2020-03-28 00:00:00</p>*/}

                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            )
        });
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="">
                                <div className="content">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="card title-card-bottom-space">
                                            <nav aria-label="breadcrumb">
                                                    <ol className="breadcrumb">
                                                        <li class="breadcrumb-item">
                                                            <Link className="" to="/admin/tableau-project/" >Project</Link>
                                                        </li>

                                                        <li aria-current="page" class="breadcrumb-item active">{this.state.project_name}</li>
                                                    </ol>
                                                </nav>
{/*                                                 <div className="header"> */}
{/*                                                     <h4 className="title">Project</h4> */}
{/*                                                     <p className="category"></p> */}
{/*                                                 </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*<div className="header">*/}
                                {/*    <h4 className="title">Transaction</h4>*/}
                                {/*    <p className="category"></p>*/}
                                {/*</div>*/}
                                <div className="content">
                                    <div className="row">
                                        {projectData}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
const mapDispatchToProps = (dispatch) =>{
  return {
  currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
  }
}
export default connect(null,mapDispatchToProps)(TableauWorkbook);